jQuery(document).ready(function($) {
    var product_temp = $('#data-single-product');
    if (product_temp.length > 0) {
        var products = getCookie('product_recent');
        if (products.length !== 0) products = JSON.parse(products);
        if (products.length == 0) {
            products = [];
        }
        var filter = {
            id: product.id,
            title: product.title,
            url: product.url,
            image: product.image,
            sale: product.sale,
            regular:product.regular,
            cat_title:product.cat_title,
            cat_url:product.cat_url
        }
        for (var i = products.length - 1; i >= 0; i--) {
            if (products[i].id == id) {
                return;
            }
        }
        products.push(filter);
        setCookie('product_recent', JSON.stringify(products), 30 * 86400);
    }

    var history = $('.recent-view');
    history.hide();
    var products = getCookie('product_recent');
    if(products.length == 0 || JSON.parse(products).length == 0){
        history.hide();
    }
    if (history.length > 0) {
        var products = getCookie('product_recent');
        if (products.length == 0) {
            history.hide();
            return false;
        } else {
            history.show();
        }
        products = JSON.parse(products);
        for (var i = products.length - 1; i >= 0; i--) {

        }
        $('.recent-slide').owlCarousel({

        });
    }
    $('.remove-all-history').on('click', function(e) {
        e.preventDefault();
        setCookie('product_recent', "", 30 * 86400);
        history.remove();
    })
    $(document).on('click', '.remove-history', function(e) {
        e.preventDefault();
        var products = getCookie('product_recent');
        if (products.length == 0) {
            history.hide();
            return false;
        } else {
            history.show();
        }
        products = JSON.parse(products);
        var product_id = $(this).attr('data-id');
        for (var i = 0; i < products.length; i++) {
            if (products[i].id == product_id) {
                products.splice(i, 1);
                break;
            }
        }
        setCookie('product_recent', JSON.stringify(products), 30 * 86400);
        if (products.length > 0) {
            $(this).parents('.owl-item').remove();
        } else {
            history.remove();
        }
    });
});